var lunch = [
    {
        "id": "7",
        "category": "lunch",
        "name": "Healthy Meal Plan",
        "img": "https://i.imgur.com/4ifqEuW.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 12.99
    },
    {
        "id": "8",
        "category": "lunch",
        "name": "Fried Chicken Beneta",
        "img": "https://i.imgur.com/5fJnbk3.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 10.99
    },
    {
        "id": "9",
        "name": "Tarragol Rubble Salmon",
        "category": "lunch",
        "img": "https://i.imgur.com/RsIx4t1.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "10",
        "name": "Indian Lunch Beneta",
        "category": "lunch",
        "img": "https://i.imgur.com/u0r90tN.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 8.99
    },
    {
        "id": "11",
        "name": "Beef Stick Glazed",
        "category": "lunch",
        "img": "https://i.imgur.com/0jxpCAI.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 12.99
    },
    {
        "id": "12",
        "name": "Honey Soi Glazed",
        "category": "lunch",
        "img": "https://i.imgur.com/CNpakkJ.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 9.99
    },


]
export default lunch;